import React, { Component } from 'react';
import Footer from "../../components/Footer";
import Utils from '../../utils/utils';
import anime from 'animejs';
import { message } from "antd";
import {withRouter} from "react-router-dom";
import Loader from '../../components/loader';
import './index.less';
import bg from '../../assets/img/bj_pro.png';
import Axios from "../../axios";

class Product extends Component{
    constructor(props){
        super(props);
        this.state={
            bgImg:'',
            isLoading:true,
            initBg:bg
        }
    }
    componentWillMount() {
        this.listRequest();//数据请求
    }

    //鼠标移上去
    handleMouse = (e,picUrl) => {
        let target = e.target;
        anime.timeline({loop: 1})
            .add({
                targets: target,
                scale:[1,1.02],
                easing: "linear",
                duration: 500,
            });
        let mask = document.getElementsByClassName('wrap-mask')[0];
        Utils.getImageColor(picUrl ,function (bgcolor) {
            let bgColor = bgcolor[0];
            anime.timeline({loop: 1})
            .add({
                targets: '.wrap-mask',
                opacity: [0,1],
                easing: "linear",
                duration: 500,
            })
            mask.style.backgroundColor=bgColor;
        });
        this.setState({
            bgImg: picUrl
        })
    };
    //鼠标移开
    leaveHandle = (e) => {
        console.log(e)
        let target = e.target;
        let mask = document.getElementsByClassName('wrap-mask')[0];
        anime.timeline({loop: 1})
            .add({
                targets: target,
                scale:[1.02,1],
                easing: "linear",
                duration: 100,
                update:()=>{
                    // target.style.color = '#fff';
                    mask.style.backgroundColor='rgba(0,0,0,0.4)';
                }
            })
            .add({
                targets: '.wrap-mask',
                opacity: [1,0],
                easing: "linear",
                duration: 500,
            })
        this.setState({
            bgImg: ''
        })
    }
    goPro = (e,id) => {
        console.log(id)
        this.props.history.push(`/pro/${id}`)
    }
    /*列表数据请求*/
    listRequest = () => {
        let _this = this;
        var params = {type:"CATEGORY",slug:'Products'};
        this.setState({
            isLoading: true,
        })
        Axios.get({
            block: '/api',
            url: '/category',
            params: params,
        }).then((data) => {
            console.log(data)
            if(data.code === 0){
                let proItems = [];
                let items = data.data;
                console.log(items)
                for(let i in items){
                    let item = items[i];
                    item.picUrl = Utils.getUrl(item.icon);
                    proItems.push(item);
                }
                this.setState({
                    proItems
                })
            }else{
                message.error(data.msg)
            }
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
        }).catch((error) => {
            console.log(error);
        })
    };
    render() {
        const { bgImg, proItems, isLoading,initBg } = this.state;
        return(
            <div>
                {
                    isLoading ? <Loader cTitle="产品" eTitle="PRODUCT"/>
                        : <div className="content-box" style={{backgroundImage: "url(" + (bgImg?bgImg:initBg) + ")"}}>
                            <header className="header-title">
                                <h1 className="white"><a href="/product">product</a></h1>
                            </header>
                            <div className="wrap-mask" style={{width: '100vw', height: '100vh'}}>

                            </div>

                                <div id="handler">
                                    <div className="" style={{display: 'none'}}>
                                        <canvas id="myCanvas"></canvas>
                                        <img id="imgs" src={bgImg} width='100' height='100' alt="img_color"/>
                                    </div>
                                    <div>
                                        <ul className="projects-wrapper" style={{transform: 'translateY(0px) translateZ(0px)'}} onMouseLeave ={(e)=>this.leaveHandle(e)}>
                                            {
                                                proItems ? proItems.map((item, index) => {
                                                    console.log(item.title)
                                                    return (
                                                        <li className="projects" key={index} >
                                                            <div className="project">
                                                                <a href="javaScript:void(0)" onClick={(e)=>this.goPro(e,item.id)}>
                                                                <span className="wr">
                                                                    <span className="txt" onMouseOver={(e) => this.handleMouse(e, item.picUrl)}>{item.title.toUpperCase()}</span>
                                                                </span>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    )
                                                }) : ''
                                            }
                                        </ul>
                                    </div>


                                 {/*<Nav/>*/}
                            </div>
                            <Footer/>
                        </div>
                }
            </div>

        )
    }
}
export default withRouter(Product);
